export default __webpack_public_path__ + "static/media/man-independent-outline-16-px.653a2402.svg";